import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Rooms from "@/components/Rooms";
import Amenities from "@/components/Amenities";
import Gallery from "@/components/Gallery";
import LocationSection from "@/components/LocationSection";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-ink text-cream">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Rooms />
        <Amenities />
        <Gallery />
        <LocationSection />
      </main>
      <Footer />
    </div>
  );
}
